// ── Seed system messages (Round 13 Phase D) ──
/** Client -> Server: plant a seed. */
export const MSG_SEED_PLANT = 'seed_plant';
/** Server -> Client: seed planted result. */
export const MSG_SEED_PLANT_RESULT = 'seed_plant_result';
/** Client -> Server: harvest a ready seed. */
export const MSG_SEED_HARVEST = 'seed_harvest';
/** Server -> Client: seed harvest result. */
export const MSG_SEED_HARVEST_RESULT = 'seed_harvest_result';
/** Server -> Client: full seed state snapshot (sent on join). */
export const MSG_SEED_SNAPSHOT = 'seed_snapshot';
/** Server -> Client: a seed was granted (from gathering or expedition). */
export const MSG_SEED_GRANTED = 'seed_granted';
//# sourceMappingURL=seeds.js.map